module.exports = __webpack_public_path__ + "img/image-soon.3b93e62b.png";